import about from "locales/en-US/about.json";
import activetrader from "locales/en-US/activetrader.json";
import affiliateProgram from "locales/en-US/affiliate-program.json";
import areasOfAvailability from "locales/en-US/areas-of-availability.json";
import awkwardAstronauts from "locales/en-US/awkward-astronauts.json";
import blog from "locales/en-US/blog.json";
import brave from "locales/en-US/brave.json";
import card from "locales/en-US/card.json";
import careers from "locales/en-US/careers.json";
import clearing from "locales/en-US/clearing.json";
import common from "locales/en-US/common.json";
import converter from "locales/en-US/converter.json";
import cryptober from "locales/en-US/cryptober.json";
import derivatives from "locales/en-US/derivatives.json";
import dollar from "locales/en-US/dollar.json";
import earn from "locales/en-US/earn.json";
import externalRedirects from "locales/en-US/external-redirects.json";
import fees from "locales/en-US/fees.json";
import frontierFund from "locales/en-US/frontier-fund.json";
import homepage from "locales/en-US/homepage.json";
import homepageNftTakeover from "locales/en-US/homepage-nft-takeover.json";
import homepagV2 from "locales/en-US/homepage-v2.json";
import howToBuy from "locales/en-US/how-to-buy.json";
import internships from "locales/en-US/internships.json";
import learn from "locales/en-US/learn.json";
import legal from "locales/en-US/legal.json";
import news from "locales/en-US/news.json";
import opportunityFund from "locales/en-US/opportunity-fund.json";
import partners from "locales/en-US/partners.json";
import pdf from "locales/en-US/pdf.json";
import prices from "locales/en-US/prices.json";
import products from "locales/en-US/products.json";
import referralClub from "locales/en-US/referral-club.json";
import security from "locales/en-US/security.json";
import settlement from "locales/en-US/settlement.json";
import share from "locales/en-US/share.json";
import staking from "locales/en-US/staking.json";
import subscribe from "locales/en-US/subscribe.json";
import titan from "locales/en-US/titan.json";
import tradingview from "locales/en-US/tradingview.json";
import token2049 from "locales/en-US/token2049.json";
import trust from "locales/en-US/trust.json";
import trustAndSafety from "locales/en-US/trust-and-safety.json";
import ukFcaRisks from "locales/en-US/uk-fca-risks.json";
import whatsNew from "locales/en-US/whats-new.json";
import whitepaper from "locales/en-US/whitepaper.json";

export const NAMESPACE_TO_TRANSLATIONS = {
  about: about,
  activetrader: activetrader,
  "affiliate-program": affiliateProgram,
  "areas-of-availability": areasOfAvailability,
  "awkward-astronauts": awkwardAstronauts,
  blog: blog,
  brave: brave,
  card: card,
  careers: careers,
  clearing: clearing,
  common: common,
  converter: converter,
  cryptober: cryptober,
  derivatives: derivatives,
  dollar: dollar,
  earn: earn,
  "external-redirects": externalRedirects,
  fees: fees,
  "frontier-fund": frontierFund,
  homepage: homepage,
  "homepage-nft-takeover": homepageNftTakeover,
  "how-to-buy": howToBuy,
  "homepage-v2": homepagV2,
  internships: internships,
  learn: learn,
  legal: legal,
  news: news,
  "opportunity-fund": opportunityFund,
  partners: partners,
  pdf: pdf,
  prices: prices,
  products: products,
  "referral-club": referralClub,
  security: security,
  settlement: settlement,
  share: share,
  staking: staking,
  subscribe: subscribe,
  titan: titan,
  tradingview: tradingview,
  token2049: token2049,
  trust: trust,
  "trust-and-safety": trustAndSafety,
  "uk-fca-risks": ukFcaRisks,
  "whats-new": whatsNew,
  whitepaper: whitepaper
} as const;

export type TranslationPath = keyof typeof PATHNAME_TO_TRANSLATION_NAMESPACES;

// TODO: Delete FILES. We can export a our version of useTranslations that narrows the type of the namespace to the ones in NAMESPACES
export const FILES = {
  COMMON: "common",
  HOMEPAGE: "homepage",
  HOMEPAGE_V2: "homepage-v2",
  HOMEPAGE_NFT: "homepage-nft-takeover",
  ABOUT: "about",
  ACTIVETRADER: "activetrader",
  AFFILIATE_PROGRAM: "affiliate-program",
  AREAS_OF_AVAILABILITY: "areas-of-availability",
  AWKWARD_ASTRONAUTS: "awkward-astronauts",
  BLOG: "blog",
  BRAVE: "brave",
  CAREERS: "careers",
  CARD: "card",
  CLEARING: "clearing",
  DOLLAR: "dollar",
  DERIVATIVES: "derivatives",
  EARN: "earn",
  EXTERNAL_REDIRECTS: "external-redirects",
  FEES: "fees",
  FRONTIER_FUND: "frontier-fund",
  INTERNSHIPS: "internships",
  LEARN: "learn",
  LEGAL: "legal",
  NEWS: "news",
  OPPORTUNITY_FUND: "opportunity-fund",
  PARTNERS: "partners",
  PDF: "pdf",
  PRICES: "prices",
  PRODUCTS: "products",
  REFERRAL_CLUB: "referral-club",
  SECURITY: "security",
  SETTLEMENT: "settlement",
  SHARE: "share",
  STAKING: "staking",
  SUBSCRIBE: "subscribe",
  TITAN: "titan",
  TRADINGVIEW: "tradingview",
  TRUST_AND_SAFETY: "trust-and-safety",
  TOKEN2049: "token2049",
  TRUST: "trust",
  WHITEPAPER: "whitepaper",
  HOW_TO_BUY: "how-to-buy",
  UK_FCA_RISKS: "uk-fca-risks",
  WHATS_NEW: "whats-new",
  CRYPTOBER: "cryptober",
  CONVERTER: "converter"
} as const satisfies Record<string, Namespace>;

export type NamespaceToTranslation = typeof NAMESPACE_TO_TRANSLATIONS;

export type Namespace = keyof typeof NAMESPACE_TO_TRANSLATIONS;

export type TranslationPathname =
  keyof typeof PATHNAME_TO_TRANSLATION_NAMESPACES;

export const LOCALES = [
  "en-US",
  "en-SG",
  "en-GB",
  "en-AU",
  "es",
  "pt",
  "it",
  "fr"
] as const;

export const LANGUAGE_DEFAULT_LOCALES = [
  "en-US",
  "es",
  "pt",
  "it",
  "fr"
] as const satisfies Locale[];

export const DEFAULT_LOCALE = "en-US" as const satisfies Locale;
export type Locale = (typeof LOCALES)[number];

export const SMARTLING_LOCALES = ["en-US", "es", "pt", "it", "fr"] as const;
export type SmartlingLocale = (typeof SMARTLING_LOCALES)[number];

// Map new simplified locales to existing locale directory structure
export const LOCALE_TO_DIRECTORY = {
  "en-US": "en-US",
  "en-SG": "en-US",
  "en-GB": "en-US",
  "en-AU": "en-US",
  es: "es-LA",
  pt: "pt-BR",
  it: "it-IT",
  fr: "fr-FR"
} as const satisfies Record<Locale, string>;

type ExtractKeys<T, Prefix extends string = ""> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? `${Prefix}${K}` | ExtractKeys<T[K], `${Prefix}${K}.`>
        : never;
    }[keyof T]
  : never;

export type NamespaceTranslationKeys = {
  [N in Namespace]: ExtractKeys<(typeof NAMESPACE_TO_TRANSLATIONS)[N]>;
};

type PathTranslationNamespaces<P extends TranslationPath> =
  (typeof PATHNAME_TO_TRANSLATION_NAMESPACES)[P][number];

type ExtractNestedKeys<
  T,
  Prefix extends string = "",
  Root extends boolean = true
> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ?
              | ExtractNestedKeys<T[K], `${Prefix}${K}.`, false>
              | (Root extends true ? never : `${Prefix}${K}`)
          : `${Prefix}${K}`
        : never;
    }[keyof T]
  : never;

export type ValidKeysForPath<P extends TranslationPath> = ExtractNestedKeys<
  {
    [K in PathTranslationNamespaces<P>]: NamespaceToTranslation[K];
  } & {
    common: NamespaceToTranslation["common"];
  }
>;

export const PATHNAME_TO_TRANSLATION_NAMESPACES = {
  "*": ["common"],
  "/": ["homepage", "homepage-v2", "homepage-nft-takeover"],
  "/about": ["about"],
  "/activetrader": ["activetrader", "products"],
  "/affiliate-program": ["affiliate-program"],
  "/affiliate-program/tr": ["affiliate-program"],
  "/affiliate-program/vn": ["affiliate-program"],
  "/apac/[country]": ["homepage"],
  "/areas-of-availability": ["areas-of-availability"],
  "/areas-of-availability/[slug]": ["areas-of-availability"],
  "/artemis/legal/[slug]": ["legal"],
  "/awkward-astronauts": ["awkward-astronauts"],
  "/blog": ["blog"],
  "/blog/[slug]": ["blog"],
  "/blog/author/[author]": ["blog"],
  "/blog/search": ["blog"],
  "/blog/type/[type]": ["blog"],
  "/brave": ["brave"],
  "/careers": ["careers"],
  "/careers/[team]": ["careers"],
  "/card": ["card"],
  "/card/[slug]": ["card"],
  "/clearing": ["clearing"],
  "/custody/whitepaper": ["whitepaper"],
  "/dollar": ["dollar"],
  "/derivatives": ["derivatives", "homepage"],
  "/earn": ["earn"],
  "/eu": ["homepage"],
  "/fees": ["fees"],
  "/fees/[slug]": ["fees"],
  "/frontier-fund": ["frontier-fund"],
  "/how-to-buy/[slug]": ["how-to-buy"],
  "/internships": ["internships", "careers"],
  "/internships-faq": ["internships", "careers"],
  "/learn": ["learn"],
  "/learn/[slug]": ["learn"],
  "/legal": ["legal"],
  "/legal/[slug]": ["legal"],
  "/news": ["news"],
  "/opportunity-fund": ["opportunity-fund"],
  "/partners": ["partners"],
  "/pdf": ["pdf"],
  "/pdf/[slug]": ["pdf"],
  "/prices": ["prices"],
  "/prices/[...coin]": ["prices"],
  "/products": ["products"],
  "/redirect": ["external-redirects"],
  "/referral-club": ["referral-club"],
  "/security": ["security"],
  "/settlement": ["settlement"],
  "/share": ["share"],
  "/share/[referralCode]": ["share"],
  "/staking": ["staking"],
  "/staking-pro-uk": ["staking"],
  "/subscribe/success": ["subscribe"],
  "/subscribe/success/[newsLetter]": ["subscribe"],
  "/titan": ["titan"],
  "/tradingview": ["tradingview"],
  "/trust-and-safety": ["trust-and-safety"],
  "/trust-center": ["trust", "homepage", "trust-and-safety"],
  "/uk": ["homepage"],
  "/apac/singapore": ["homepage"],
  "/uk-fca-risks": ["uk-fca-risks"],
  "/uk-fca-risks/product-risks": ["uk-fca-risks"],
  "/promo/cryptober": ["cryptober"],
  "/converter/[[...segment]]": ["converter"],
  "/marketplace": ["fees"]
} as const satisfies Record<string, Namespace[]>;

export const LANGUAGES = {
  "en-US": "English",
  "en-SG": "English (Singapore)",
  "en-GB": "English (UK)",
  "en-AU": "English (Australia)",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  fr: "Français"
} as const satisfies Record<Locale, string>;

export const COUNTRY_TO_SUGGESTED_LOCALES = {
  US: ["en-US"],
  SG: ["en-SG"],
  GB: ["en-US"],
  IE: ["en-US"]
} as const satisfies Record<string, Locale[]>;

// Map country codes to display names
export const COUNTRY_NAMES = {
  US: "United States",
  SG: "Singapore",
  GB: "United Kingdom",
  IE: "Ireland"
} as const satisfies Record<string, string>;

// Map locale codes to the region name they represent
export const LOCALE_TO_REGION_LABEL = {
  "en-US": "United States",
  "en-SG": "Singapore",
  "en-GB": "United Kingdom",
  "en-AU": "Australia",
  es: "Spanish",
  pt: "Portuguese",
  it: "Italian",
  fr: "French"
} as const satisfies Record<Locale, string>;
